import { render, staticRenderFns } from "./agent-card.vue?vue&type=template&id=057bc6d6&scoped=true&"
import script from "./agent-card.vue?vue&type=script&lang=js&"
export * from "./agent-card.vue?vue&type=script&lang=js&"
import style0 from "./agent-card.vue?vue&type=style&index=0&id=057bc6d6&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "057bc6d6",
  null
  
)

export default component.exports